// extracted by mini-css-extract-plugin
export default {"header":"Header_header__yYtvA","logo":"Header_logo__SGF3E","logoText":"Header_logoText__81fmF","actions":"Header_actions__mUNUD","buttons":"Header_buttons__LcENG"};